import { scrollSmootherInstance } from "../globals/gsap";
import { ScrollSpy } from "bootstrap";

class Anchors {
  stateClasses = {
    active: 'anchors__link--active',
  };
  constructor($el, $stickyContent) {
    this.$el = $el;
    this.$stickyContent = $stickyContent;
    this.$stickyNav = $('[data-sticky="nav"]');
    this.$links = this.$el.find('[data-anchors="link"]');
    this.$scrollContainer = $('[data-scroll-smoother="wrapper"]');
    this.init();
  }

  init = () => {
    this.$links.on('click', this.handleClick);

    // this.scrollSpy = new ScrollSpy(this.$el);
    this.scrollSpy = new ScrollSpy(this.$stickyContent, {
      target: this.$el,
    });
  }

  handleClick = (e) => {
    e.preventDefault();

    const target = $(e.currentTarget).attr('href');

    scrollSmootherInstance.scrollTo(target, true, `top ${this.$stickyNav.outerHeight() + 24}px`);
  }
}

export default Anchors;